export default [
	{
		modulo: 19,
		privilegio: 216,
		routerName: 'ticket',
		routerPath: '/ticket',
		componentName: 'Ticket',
		componentPath: 'modules/layout/suporte/ticket/main'
	},
	{
		modulo: 19,
		privilegio: 216,
		routerName: 'ticket-cadastro',
		routerPath: '/ticket/cadastro',
		componentName: 'TicketCadastro',
		componentPath: 'modules/layout/suporte/ticket/cadastro'
	},
	{
		modulo: 19,
		privilegio: 216,
		routerName: 'ticket-atualizacao',
		routerPath: '/ticket/atualizacao',
		componentName: 'TicketAtualizacao',
		componentPath: 'modules/layout/suporte/ticket/atualizacao'
	},
	{
		modulo: 19,
		privilegio: 219,
		routerName: 'suporte-termo-de-uso',
		routerPath: '/suporte-termo-de-uso',
		componentName: 'SuporteTermoDeUso',
		componentPath: 'modules/layout/suporte/termo-de-uso/main'
	},
	{
		modulo: 19,
		privilegio: 224,
		routerName: 'suporte-exportar-dados',
		routerPath: '/suporte-exportar-dados',
		componentName: 'SuporteExportarDados',
		componentPath: 'modules/layout/suporte/exportar-dados/main'
	},
	{
		modulo: 19,
		privilegio: 231,
		routerName: 'faq',
		routerPath: '/faq',
		componentName: 'SuporteFAQ',
		componentPath: 'modules/layout/suporte/faq/main'
	}
]
